import { Button } from "@9amhealth/shared";
import styled from "@emotion/styled";
import React, { FC, useState } from "react";
import { KnownProgram } from "src/state/ProgramBloc/ProgramBloc";
import Progress from "src/ui/components/Progress/Progress";
import TaskList from "src/ui/components/TaskList/TaskList";
import Translate from "src/ui/components/Translate/Translate";
import {
  glpContinuationTasksToShow,
  TaskKey
} from "src/state/TaskManagementBloc/TaskManagementBloc";
import { TasksContext } from "src/constants/tasksContext";
import { AppPopup } from "../AppQueryPopups/AppQueryPopupsBloc";
import { translate } from "lib/blocs/TranslateionBloc";
import CollectionItemLink from "../StyledComponents/CollectionItemLink";
import Collection from "src/ui/components/StyledComponents/Collection";
import { OpenBrowser } from "src/hybrid/components/Browser";

const Container = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h5`
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
`;

const Counter = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
`;

const ProgressTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

interface Props {
  onClose: () => void;
}

export const GlpContinuationTasksWithoutContext: FC<Props> = ({ onClose }) => {
  const { terminalTasks, totalTasks } = React.useContext(TasksContext);

  const allDone = terminalTasks === totalTasks;

  return (
    <Container>
      <ProgressTitleContainer>
        <Title>
          <Translate msg="glpContinuation.yourProgress" />
        </Title>
        <Counter>
          {terminalTasks}/{totalTasks}
        </Counter>
      </ProgressTitleContainer>
      <Progress percent={terminalTasks / totalTasks} />

      <nine-spacer s="lg" />
      <TaskList
        showBadges
        filterVisibleTasks={(task) =>
          glpContinuationTasksToShow.includes(task.slug as TaskKey)
        }
        programs={[KnownProgram.ONBOARDING]}
        onTaskCompletionBehavior={AppPopup.glpContinuation}
      />
      <nine-spacer s="xs" />
      <p className="as-caption">
        <Translate msg="glpContinuation.taskCollection" />
      </p>

      <Collection>
        <CollectionItemLink
          reverseLabelOrder
          status={translate("glpContinuation.articles.length")}
          label={translate("glpContinuation.articles.title")}
          card={true}
          onClick={() => {
            void OpenBrowser(
              "https://join9am.com/blog/speeding-up-your-renewal",
              {
                useBaseUrl: false,
                presentationStyle: "fullscreen"
              }
            );
          }}
          imageAlt={translate("glpContinuation.articles.title")}
          imageSrc="https://cdn.sanity.io/images/g38rxyoc/production/844b571a3d5f8f826f9cf1bba16aecac94dc2ac8-256x254.png"
          size="large"
        />
      </Collection>
      <nine-spacer s="lg" />
      {allDone && (
        <Button
          onPress={onClose}
          style={{
            margin: "0 auto"
          }}
        >
          Continue
        </Button>
      )}
    </Container>
  );
};

export const GlpContinuationTasks: FC<Props> = (props) => {
  const [terminalTasks, setTerminalTasks] = useState(0);
  const [totalTasks, setTotalTasks] = useState(0);

  return (
    <TasksContext.Provider
      value={{ terminalTasks, setTerminalTasks, totalTasks, setTotalTasks }}
    >
      <GlpContinuationTasksWithoutContext {...props} />
    </TasksContext.Provider>
  );
};
